<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisarOrdemServico",
      @limpar="clearFiltroOrdemServico",
      :showOs="true",
      :showMunicipios="true",
      :configuracaoFiltro="configuracaoFiltro"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonCadastraOS="true",
    :showButtonAssinatura="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :hasExpansivel="true",
    :subProcessos="subProcessos"
    :pagina="filtro.pagina",
    @updateListagem="refreshOrdemServico",
    @buscarSubProcessos="buscarSubProcessos"
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="CRIAR_ORDEM_SERVICO",
    @visualizarProcesso="VISUALIZAR_PROCESSO",
    @changePageSubprocesso="changePageSubprocesso"
  )
</template>

<script>

import FileSaver from 'file-saver'
import axios from '@/utils/api'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('ORDEM_SERVICO'),
      items: [],
      totalElements: 0,
      processosSelecionados: [],
      showModalResponsavel: false,
      processoTrocado: null,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      protocolo: null,
      showModalVisualizarProcesso: null,
      configuracaoFiltro: {
        filtroOrdemServico: filtro?.filtroOrdemServico?.ORDEM_SERVICO || [],
        filtroStatusOrdemServico: filtro?.filtroStatusOrdemServico?.ORDEM_SERVICO || [],
        filtroMunicipio: filtro.filtroMunicipio.ORDEM_SERVICO || []
      },
      colunas: [
        { id: 1, titulo: 'Ordem de Serviço', propriedade: 'numero', ordem: 1, acoes: [] },
        { id: 2, titulo: 'Responsável', propriedade: 'responsavel', ordem: 2, acoes: [] },
        { id: 3, titulo: 'Status', propriedade: 'status', sortable: false, ordem: 3, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [] },
        {
          id: 5, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Editar OS', icone: 'fa-edit', codigo: 'EDITAR_ORDEM_SERVICO', ordem: 1, show: this.showEditarOs },
            { id: 2, nome: 'Baixar Ordem de Serviço', icone: 'fa-download', codigo: 'DOWNLOAD_ORDEM_SERVICO', ordem: 1, show: this.showDownloadOs }
          ]
        }
      ],
      subProcessos: [],
      idOs: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.initOrdemServico()
  },

  watch: {
    async '$route' (to, from) {
      this.initOrdemServico()
    }
  },

  methods: {
    showAnalisaProcesso (processo, acao) {
      return this.processoIsAguardandoAnalise(processo)
    },
    CRIAR_ORDEM_SERVICO () {
      this.$router.push({
        name: 'CAIXA_PROCESSOS_OS'
      })
    },
    EDITAR_ORDEM_SERVICO (_this, { item }) {
      this.$router.push({
        name: 'LISTAGEM_PROCESSO_ORDEM_SERVICO',
        params: {
          numero: item.id,
          edicao: true
        }
      })
    },

    EXCLUIR_ORDEM_SERVICO (_this, { item }) {
      _this.$confirm('Tem certeza que deseja remover este item?', 'Atenção!', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(async () => {
        await _this.deleteOrdemServicoPorId(item.id)
        await _this.init()
      })
    },

    async DOWNLOAD_ORDEM_SERVICO (_this, { item }) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: item.documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, item.documento.nome)
    },

    VISUALIZAR_PROCESSO (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    async buscarSubProcessos (idOs, page) {
      this.idOs = idOs
      const subProcessos = await axios({
        method: 'GET',
        url: `subprocesso/ordemServico?idOs=${idOs}&page=${page}&size=10`
      })
      this.subProcessos = subProcessos
    },

    async changePageSubprocesso (page) {
      const subProcessos = await axios({
        method: 'GET',
        url: `subprocesso/ordemServico?idOs=${this.idOs}&page=${page - 1}&size=10`
      })
      this.subProcessos = subProcessos
    },
    async sort (item) {
      this.filtro.ordem = item.ordem
      this.filtro.ordemDirecao = item.tipo
      const data = await this.buscar()
      this.items = data.content || data.processos.content
      this.totalElements = data.totalElements || data.processos.totalElements
      if (data.processos) {
        this.infoPrazos = {
          totalVencidos: data.totalVencidos,
          totalAVencer: data.totalAVencer,
          totalEmDia: data.totalEmDia
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaOrdemServicoListagem.vue